<div>
  <div>
    Login failed. Please try again.

    {{ this.error }}

    <a href="/">Try again</a>
  </div>

  @if (this.QuotaExceededError) {
    <div>
      MS Authentication Library has caused a quota exceeded error, this needs to be cleared before we can try to login again.
      <button (click)="clearStorage()">Clear localstorage</button>
    </div>
  }
</div>
